import classNames from 'clsx';
import { isEmpty } from 'lodash';
import React from 'react';

import Translation from '@swf/components/Translation/Translation';
import Open from '@swf/core/assets/icons/open-leaderboard.svg';
import type { CasinoRace } from '@swf/core/types/CasinoRaces';

import Completed from '../Completed/Completed';

import {
  TXTWCL_Completed_Races,
  TXTWCL_Show_less,
  TXTWCL_Show_more
} from './CompletedGrid.messages.json';
import styles from './CompletedGrid.scss';

interface State {
  expanded: boolean;
}

export interface Props {
  races: CasinoRace[];
  showLeaderboard(race: CasinoRace): () => void | Promise<void>;
  fetchCompleted(): void;
}

class CompletedGrid extends React.PureComponent<Props, State> {
  state = { expanded: false };

  toggleExpand = () =>
    this.setState(
      (prevState) => ({ expanded: !prevState.expanded }),
      () => {
        if (this.state.expanded) {
          this.props.fetchCompleted();
        }
      }
    );

  renderBlock(raceList: CasinoRace[]) {
    const { showLeaderboard } = this.props;
    return raceList.map((race) => (
      <div key={race.id} className={styles.race}>
        <Completed onStanding={showLeaderboard(race)} {...race} />
      </div>
    ));
  }

  render() {
    const { races } = this.props;

    return (
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>{TXTWCL_Completed_Races.defaultMessage}</h2>
        </div>
        <div className={styles.grid}>
          {this.renderBlock(races.slice(0, 4))}
          {this.state.expanded &&
            !isEmpty(races) &&
            races.length > 4 &&
            this.renderBlock(races.slice(4))}
        </div>
        <div className={styles.open} onClick={this.toggleExpand}>
          <div className={styles.title}>
            <Translation {...(this.state.expanded ? TXTWCL_Show_less : TXTWCL_Show_more)} />
            <Open className={classNames({ [styles.down]: !this.state.expanded })} />
          </div>
        </div>
      </div>
    );
  }
}

export default CompletedGrid;
